import { render } from "./ExpensesByMonth.vue?vue&type=template&id=7f7970aa"
import script from "./ExpensesByMonth.vue?vue&type=script&lang=js"
export * from "./ExpensesByMonth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__